import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { ProtocolAnswerHttpEditRequestModel } from '../protocolAnswer/types';
import {
  broadcastUpdatedProtocolAnswer,
  broadcastUpdatedProtocolAnswerError,
} from 'serviceWorker/broadcasts/protocolAnswer';
import { upsertProtocolAnswer } from 'serviceWorker/db/inspections/inspections';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';
import { scopeOfQueuedRequest } from 'serviceWorker/helpers/dataScope';

export async function broadcastProtocolAnswerResponse(
  request: HttpRequestEntity,
  response: ProtocolAnswerInDto | { error: unknown }
): Promise<void> {
  if (request.method !== 'PUT') {
    return broadcastUpdatedProtocolAnswerError(
      new Error(`${request.method} method not supported for protocolAnswer`),
      (request as ProtocolAnswerHttpEditRequestModel).data?.uniqueId
    );
  }

  const putRequest = request as ProtocolAnswerHttpEditRequestModel;

  if ('error' in response && response.error) {
    return broadcastUpdatedProtocolAnswerError(
      response.error,
      putRequest.data.uniqueId
    );
  }

  const answer = response as ProtocolAnswerInDto;

  await scopeOfQueuedRequest(request).write(() =>
    upsertProtocolAnswer({
      inspectionId: putRequest.data.inspectionId,
      protocolItemId: putRequest.data.protocolItemId,
      answer,
    })
  );

  return broadcastUpdatedProtocolAnswer(answer, putRequest.data.uniqueId);
}
